import React from "react";
import { MarkerType } from "react-flow-renderer";
import astronautImage from "../images/nasa-astronaut-pic.jpg";
import { Link } from "react-router-dom";

const level1 = "rgb(17,3,3, 0.1)";
const level2 = "rgb(38, 89, 93, 0.4)";
const level3 = "rgb(20,28,39, 0.9)";
const level4 = "#3c5475";
const level5 = "#4517d1";
const level6 = "#de723a";
const black = "yellow";
const white = "white";
const transparent = "00FFFFFF";
const spaceColor = "#141c26";

export const nodes = [
  {
    id: "1",
    type: "input",
    data: {
      label: (
        <>
          <strong>CSS Animation</strong>
        </>
      ),
    },
    position: { x: 0, y: 0 },
    style: {
      background: level1,
      color: black,
      border: "1px solid #222138",
      width: 300,
    },
  },

  {
    id: "2",
    data: {
      label: (
        <>
          <strong>animation-delay</strong>
          <p>
            Specifies the amount of time to wait from applying the animation to
            an element before beginning to perform the animation.
            <br />
            <br />
            The animation can start later, immediately from its beginning, or
            immediately and partway through the animation.
            <br />
            <br />
            Syntax: animation-delay: (time here in seconds or milliseconds)
          </p>
          <iframe
            height="400"
            width="100%"
            scrolling="no"
            title="animation delay"
            src="https://codepen.io/jonathanelias1/embed/preview/eYryxOL?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/eYryxOL">
              animation delay
            </a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: -2780, y: 2000 },
    style: {
      background: level3,
      color: black,
      border: "1px solid #222138",
      width: 800,
    },
  },

  {
    id: "3",
    data: {
      label: (
        <>
          <strong>animation-direction</strong>
          <p>
            Sets whether an animation should play forward, backward, or
            alternate back and forth between playing the sequence forward and
            backward. <br />
            <br />
            The direction can be either normal, reverse, alternate,
            alternate-reverse, or a combination of any of these such as
            alternate, reverse, normal. <br />
            <br />
            Syntax: animation-direction: (direction here)
          </p>
          <iframe
            height="350"
            width="100%"
            scrolling="no"
            title="animation delay"
            src="https://codepen.io/jonathanelias1/embed/preview/zYjpybM?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/zYjpybM">
              animation delay
            </a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: -1980, y: 2000 },
    style: {
      background: level3,
      color: black,
      border: "1px solid #222138",
      width: 800,
    },
  },

  {
    id: "4",
    data: {
      label: (
        <>
          <strong>animation-duration</strong>
          <p>
            Sets the length of time that an animation takes to complete one
            cycle.
          </p>
          <p>Syntax: animation-duration: (time)</p>

          <iframe
            height="350"
            width="100%"
            scrolling="no"
            title="animation-duration"
            src="https://codepen.io/jonathanelias1/embed/preview/JjvMxYg?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/JjvMxYg">
              animation-duration
            </a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: -1170, y: 2000 },
    style: {
      background: level3,
      color: black,
      border: "1px solid #222138",
      width: 800,
    },
  },

  {
    id: "5",
    data: {
      label: (
        <>
          <strong>animation-fill-mode</strong>
          <p>
            Sets how a CSS animation applies styles to its target before and
            after its execution.
          </p>
          <p>
            The direction can either be none, forwards, backwards, both or a
            combination of any of these such as none, backwards, forwards
          </p>
          <p>Syntax: animation-fill-mode: (direction)</p>

          <iframe
            height="1000"
            width="100%"
            scrolling="no"
            title="animation-duration"
            src="https://codepen.io/jonathanelias1/embed/preview/abGEXNr?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/abGEXNr">
              animation-duration
            </a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: -366, y: 2000 },
    style: {
      background: level3,
      color: black,
      border: "1px solid #222138",
      width: 1000,
    },
  },

  {
    id: "6",
    data: {
      label: (
        <>
          <strong>animation-iteration-mode</strong>
          <p>
            Sets the number of times an animation sequence should be played
            before stopping.
          </p>
          <p>
            Options for the amount include infinite, a numeric value, or a
            combination such as 2, 0 , infinite.
          </p>
          <p>Syntax: animation-iteration-count: (amount)</p>
          <iframe
            height="550"
            width="100%"
            scrolling="no"
            title="gradient color"
            src="https://codepen.io/jonathanelias1/embed/preview/wvjrERp?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/wvjrERp">
              gradient color
            </a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: 666, y: 2000 },
    style: {
      background: level3,
      color: black,
      border: "1px solid #222138",
      width: 800,
    },
  },
  {
    id: "7",
    data: {
      label: (
        <>
          <strong>animation-play-state</strong>
          <p>Sets whether an animation is running or paused.</p>

          <iframe
            height="500"
            width="100%"
            scrolling="no"
            title="animation-name"
            src="https://codepen.io/jonathanelias1/embed/preview/eYrGLaa?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/eYrGLaa">
              animation-name
            </a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: 2300, y: 2000 },
    style: {
      background: level3,
      color: black,
      border: "1px solid #222138",
      width: 500,
    },
  },
  {
    id: "8",
    data: {
      label: (
        <>
          <strong>animation-timing-function</strong>
          <p>
            Sets how an animation progresses through the duration of each cycle.
          </p>
          <p>
            The options include ease, ease-in, ease-out, ease-in-out, linear,
            step-start, step-end, cubic-bezier, steps, or a combination of
            these.{" "}
          </p>
          <iframe
            height="1100"
            width="100%"
            scrolling="no"
            title="animation-timing-function Explained"
            src="https://codepen.io/jonathanelias1/embed/preview/KKRXGwb?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/KKRXGwb">
              animation-timing-function Explained
            </a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: 2850, y: 2000 },
    style: {
      background: level3,
      color: black,
      border: "1px solid #222138",
      width: 800,
    },
  },
  {
    id: "9",
    data: {
      label: (
        <>
          <strong>animation</strong>
          <p>
            An animation lets an element gradually change from one style to
            another.
            <br /> <br />
            You can change as many CSS properties you want, as many times as you
            want.
            <br /> <br />
            To use CSS animation, you must first specify some keyframes for the
            animation.
            <br /> <br />
            Keyframes hold what styles the element will have at certain times.
          </p>
          <p>
            Using the animation shorthand: <br />
            Syntax: animation: (animation-delay, animation-direction,
            animation-duration, animation-fill-mode, animation-iteration-count,
            animation-name, animation-play-state, animation-timing-function
          </p>
        </>
      ),
    },
    position: { x: -350, y: 220 },
    style: {
      background: level2,
      color: black,
      border: "1px solid #222138",
      width: 1000,
    },
  },
  {
    id: "10",
    data: {
      label: (
        <>
          <strong>@keyframes</strong>
          <p>
            When you specify CSS styles inside the @keyframes rule, the
            animation will gradually change from the current style to the new
            style at certain times.
          </p>
          <iframe
            height="900"
            width="100%"
            scrolling="no"
            title="animation example"
            src="https://codepen.io/jonathanelias1/embed/preview/zYjprdL?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/zYjprdL">
              animation example
            </a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: -350, y: 800 },
    style: {
      background: level2,
      color: black,
      border: "1px solid #222138",
      width: 1000,
    },
  },
  {
    id: "11",
    data: {
      label: (
        <>
          <strong>Example 1</strong>
          <p></p>
          <iframe
            height="400"
            width="100%"
            scrolling="no"
            title="animation-timing-function"
            src="https://codepen.io/jonathanelias1/embed/preview/QWrqZjJ?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/QWrqZjJ">
              animation-timing-function
            </a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: -500, y: 3800 },
    style: {
      background: level3,
      color: black,
      border: "1px solid #222138",
      width: 800,
    },
  },

  {
    id: "12",
    data: {
      label: (
        <>
          <strong>animation-name</strong>
          <p>
            Specifies the names of one or more @keyframes at-rules that describe
            the animation to apply to an element. Multiple @keyframe at-rules
            are specified as a comma-separated list of names. If the specified
            name does not match any @keyframe at-rule, no properties are
            animated.
          </p>
          <p>You can apply single or multiple animation-names </p>

          <iframe
            height="600"
            width="100%"
            scrolling="no"
            title="animation-fill-mode"
            src="https://codepen.io/jonathanelias1/embed/preview/gOzoqxR?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/gOzoqxR">
              animation-fill-mode
            </a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: 1484, y: 2000 },
    style: {
      background: level3,
      color: black,
      border: "1px solid #222138",
      width: 800,
    },
  },

  {
    id: "13",
    data: {
      label: (
        <>
          <strong>Example 2</strong>
          <p></p>
          <iframe
            height="700"
            width="100%"
            scrolling="no"
            title='Animated "text-shadow" pattern'
            src="https://codepen.io/jonathanelias1/embed/preview/PoeELdL?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/PoeELdL">
              Animated &quot;text-shadow&quot; pattern
            </a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: 300, y: 3800 },
    style: {
      background: level3,
      color: black,
      border: "1px solid #222138",
      width: 900,
    },
  },

  {
    id: "14",
    data: {
      label: (
        <>
          <strong>Examples</strong>
          <p></p>
        </>
      ),
    },
    position: { x: 44, y: 3500 },
    style: {
      background: level2,
      color: black,
      border: "1px solid #222138",
      width: 180,
    },
  },

  // {
  //   id: "15",
  //   data: {
  //     label: (
  //       <>
  //         <strong></strong>
  //         <p></p>
  //       </>
  //     ),
  //   },
  //   position: { x: 0, y: 200 },
  //   style: {
  //     background: level3,
  //     color: black,
  //     border: "1px solid #222138",
  //     width: 180,
  //   },
  // },

  // {
  //   id: "16",
  //   data: {
  //     label: (
  //       <>
  //         <strong></strong>
  //         <p></p>
  //       </>
  //     ),
  //   },
  //   position: { x: 0, y: 200 },
  //   style: {
  //     background: level3,
  //     color: black,
  //     border: "1px solid #222138",
  //     width: 180,
  //   },
  // },

  // End of items
];

export const edges = [
  {
    id: "e1-9",
    source: "1",
    target: "9",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  {
    id: "e9-2",
    source: "9",
    target: "2",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  {
    id: "e9-3",
    source: "9",
    target: "3",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  {
    id: "e9-4",
    source: "9",
    target: "4",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  {
    id: "e9-5",
    source: "9",
    target: "5",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  {
    id: "e9-6",
    source: "9",
    target: "6",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  {
    id: "e9-7",
    source: "9",
    target: "7",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  {
    id: "e9-8",
    source: "9",
    target: "8",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  {
    id: "e9-10",
    source: "9",
    target: "10",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  {
    id: "e9-12",
    source: "9",
    target: "12",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  {
    id: "e9-14",
    source: "9",
    target: "14",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  {
    id: "e14-11",
    source: "14",
    target: "11",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  {
    id: "e14-13",
    source: "14",
    target: "13",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  //   {
  //     id: "e8-10",
  //     source: "8",
  //     target: "10",
  //     animated: true,
  //     style: { stroke: "#f6ab6c" },
  //     markerEnd: {
  //       type: MarkerType.ArrowClosed,
  //     },
  //   },

  //END
];
